import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./pages/Home/Home";
import Install from "./pages/Install/Install";
import Invite from "./pages/Invite/Invite";
import "remixicon/fonts/remixicon.css";
import arrowIcon from "./assets/svg/arrow.svg";
import returnsWealthLogo from "./assets/images/returns-wealth-logo.png";
import { useEffect, useState } from "react";
import Cookies from 'js-cookie';
import Stock from "./pages/Stock/Stock";
import Main from "./pages/Main/Main";
import Subscribe from "./pages/Subscribe/Subscribe";
import Analyze from "./pages/Analyze/Analyze";
import Portfolio from "./pages/Portfolio/Portfolio";
import AutomatedPortfolio from "./pages/AutomatedPortfolio/AutomatedPortfolio";
import Kyc from "./pages/Kyc/Kyc";
import Options from "./pages/Option/Option";
import Futures from "./pages/Future/Future";
import Multibagger from "./pages/Multibagger/Multibagger";
import Install2 from "./pages/Install2/Install2";
import UserAgreement from "./pages/UserAgreement/UserAgreement";
import UnderReview from "./pages/UserAgreement/UnderReview";
import Loader from "./pages/Loader/Loader";


const Layout = ({ children }: { children: React.ReactNode }) => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const adSource = searchParams.get('adSource');
  const hideLayout = location.pathname === "/install";
  const [ip, setIp] = useState<string | null>(null);
  const [fbc, setFbc] = useState<string | null>(null);
  const [fbp, setFbp] = useState<string | null>(null);
  const [userAgent, setUserAgent] = useState<string | null>(null);

  useEffect(() => {
    // Get the _fbc and _fbp cookies
    const fbc = Cookies.get('_fbc') || null; // Facebook Click ID (fbc)
    const fbp = Cookies.get('_fbp') || null; // Facebook Pixel ID (fbp)
    const ua = navigator.userAgent || null;

    

    setFbc(fbc);
    setFbp(fbp);
    setUserAgent(ua);

    // Log the values to the console
    console.log("Facebook Click ID (fbc):", fbc);
    console.log("Facebook Pixel ID (fbp):", fbp);
    console.log("User Agent:", ua);

    fetch('https://api.ipify.org?format=json')
    .then(response => response.json())
    .then(data => {
      const userIp = data.ip;
      setIp(userIp);
      console.log("User IP:", userIp);

      if (isValidData(userIp, fbc, fbp)) {
        // If valid, send the API request
        sendApiRequest(userIp, fbc, fbp, ua);
      } else {
        console.error("One or more required values are missing or invalid.");
      }
    })
    .catch(error => {
      console.error("Error fetching IP address:", error);
    });
  }, []);

  // Function to validate if the data is not null, empty, or undefined
  const isValidData = (ip: string | null, fbc: string | null, fbp: string | null) => {
    return ip && fbc && fbp && ip.trim() !== "" && fbc.trim() !== "" && fbp.trim() !== "";
  };

  // Function to send the API request
  const sendApiRequest = (ip: string, fbc: string | null, fbp: string | null, ua:string | null) => {
    const apiUrl = "https://tradeinsights.co.in/v1/api/metas/create";
    const payload: any = {
      ip: ip,
      fbc: fbc,
      fbp: fbp,
      user_agent: ua,
    };

    // Include adSource in the payload if it exists
    if (adSource) {
      payload.ad_source = adSource;
    }

    fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(response => response.json())
      .then(data => {
        console.log("API response:", data);
      })
      .catch(error => {
        console.error("Error sending API request:", error);
      });
  };

  return hideLayout ? (
    <>{children}</>
  ) : (
    <>
      <Header />
      {children}
      <Footer />
      <button
        onClick={() => {
          const userAgent = navigator.userAgent || navigator.vendor;
          if (/android/i.test(userAgent)) {
            window.location.href =
              "https://play.google.com/store/apps/details?id=com.optionbase.optionbase&hl=ln";
          } else if (
            /iPad|iPhone|iPod/.test(userAgent) ||
            /Macintosh/.test(userAgent)
          ) {
            window.location.href =
              "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692";
          } else {
            window.location.href =
              "https://apps.apple.com/in/app/returns-stocks-investments/id6736361692"; // Default to App Store
          }
        }}
        className="downloadNowParent"
      >
        <span className="downloadContent">
          Download{" "}
          <img
            src={returnsWealthLogo}
            alt="Returns"
            className="returnsWealthLogo"
          />{" "}
          App
          <img
            src={arrowIcon}
            alt="Arrow Icon"
            style={{
              width: "14px",
              height: "14px",
              fontWeight: "400",
              marginLeft: "4px",
              verticalAlign: "middle",
            }}
          />
        </span>
      </button>
    </>
  );
};

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/install" element={<Install />} />
        <Route path="/install2" element={<Install2 />} />
        <Route path="/invite/:invite_id" element={<Invite />} />
        <Route path="/stocks/:status" element={<Stock />} />
        <Route path="/options/:status" element={<Options />} />
        <Route path="/futures/:status" element={<Futures />} />
        <Route path="/multibagger/:status" element={<Multibagger />} />
        <Route path="/subscribe" element={<Subscribe />} />
        <Route path="/analyze" element={<Analyze />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/automated-portfolio" element={<AutomatedPortfolio />} />
        <Route path="/kyc" element={<Kyc />} />
        <Route path="/user-agreement" element={<UserAgreement />} />
        <Route path="/home" element={<Main />} />
        <Route path="/under-review" element={<UnderReview />} />
        <Route path="/loader" element={<Loader />} />

        <Route
          path="*"
          element={
            <Layout>
              <Home />
            </Layout>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
